<template>
  <v-container fluid grid-list-lg>
    <ValidationObserver ref="general">
      <v-layout wrap>
        <v-flex lg4 sm6 xs12>
          <ValidationProvider
            name="cuit del empleador"
            rules="required|digits:11">
            <v-text-field
              label="Cuit"
              v-model="empleoEditor.cui"
              mask="##-########-#"
              clearable
              v-validate="'required'"
              required
              data-vv-name="cuit del empleador"
              append-outer-icon="search"
              @click:append-outer="buscarEmpleadorPorCui()"
              slot-scope="{ errors, valid }"
              :error-messages="errors"
              :success="valid"></v-text-field>
          </ValidationProvider>
        </v-flex>
        <v-flex lg4 sm6 xs12>
          <ValidationProvider name="empleador" rules="required|max:100">
            <v-text-field
              label="Empleador"
              v-model="empleoEditor.empleador"
              required
              data-vv-name="empleador"
              slot-scope="{ errors, valid }"
              :error-messages="errors"
              :success="valid"
              disabled></v-text-field>
          </ValidationProvider>
        </v-flex>

        <v-flex lg4 class="hidden-md-and-down"> </v-flex>

        <v-flex lg4 sm6 xs12>
          <ValidationProvider
            name="característica de la actividad"
            rules="required|min_value:1">
            <v-autocomplete
              v-model="empleoEditor.situacionLaboralActividadId"
              :items="listSituacionesLaboralesActividadesDisponibles"
              required
              item-text="descripcion"
              item-value="id"
              label="Situación Laboral"
              :menu-props="{ minWidth: '200' }"
              data-vv-name="característica de la actividad"
              slot-scope="{ errors, valid }"
              :error-messages="errors"
              :success="valid"></v-autocomplete>
          </ValidationProvider>
        </v-flex>
        <v-flex lg4 sm6 xs12>
          <v-autocomplete
            v-model="empleoEditor.situacionLaboralId"
            :items="listSituacionesLaborales"
            disabled
            item-text="descripcion"
            item-value="id"
            label="Tipo de Actividad"
            :menu-props="{ minWidth: '200' }"></v-autocomplete>
        </v-flex>
        <v-flex lg3 sm6 xs12 v-if="empleoEditor.situacionLaboralId === 4">
          <v-autocomplete
            v-model="empleoEditor.subSituacionLaboralId"
            :items="listSubSituacionesLaborales"
            item-text="descripcion"
            item-value="id"
            label="Sub-Situación Laboral"
            :menu-props="{ minWidth: '200' }"></v-autocomplete>
        </v-flex>
        <!-- {{ empleoEditor }} -->
        <v-flex lg4 sm6 xs12>
          <v-autocomplete
            v-model="empleoEditor.orden"
            :items="listOrdenEmpleo"
            item-text="descripcion"
            item-value="id"
            label="Esta es la Fuente de Ingresos"
            :menu-props="{ minWidth: '200' }"></v-autocomplete>
        </v-flex>
      </v-layout>
    </ValidationObserver>

    <v-window v-model="uiCarga">
      <v-window-item :value="1">
        <ValidationObserver ref="sit1">
          <v-layout wrap>
            <v-flex lg2 sm6 xs12 v-if="showField('cargo')">
              <v-text-field
                label="Cargo"
                v-model="empleoEditor.cargo"
                data-vv-name="cargo"></v-text-field>
            </v-flex>

            <v-flex lg2 sm6 xs12 v-if="showField('seccion')">
              <v-text-field
                label="Sección"
                v-model="empleoEditor.seccion"
                data-vv-name="sección"></v-text-field>
            </v-flex>

            <v-flex lg4 sm6 xs12 v-if="showField('actividad')">
              <v-autocomplete
                v-model="empleoEditor.actividadLaboralId"
                :items="listActividadesLaborales"
                item-text="descripcion"
                item-value="id"
                label="Actividad"
                :menu-props="{ minWidth: '200' }"></v-autocomplete>
            </v-flex>

            <v-flex
              lg4
              class="hidden-md-and-down"
              v-if="showField('actividad')">
            </v-flex>

            <v-flex lg2 sm6 xs12 v-if="showField('legajo')">
              <v-text-field
                label="Nº Legajo"
                v-model="empleoEditor.legajo"
                data-vv-name="legajo laboral"></v-text-field>
            </v-flex>

            <v-flex lg2 sm6 xs12 v-if="showField('fechaIngreso')">
              <ValidationProvider name="inicio de actividades" rules="required">
                <v-text-field
                  label="Inicio Actividades"
                  v-model="empleoEditor.fechaIngreso"
                  type="date"
                  data-vv-name="fecha de ingreso"
                  slot-scope="{ errors, valid }"
                  :error-messages="errors"
                  :success="valid"></v-text-field>
              </ValidationProvider>
            </v-flex>

            <v-flex lg2 sm6 xs12 v-if="showField('jefe')">
              <v-text-field
                label="Jefe"
                v-model="empleoEditor.jefe"
                data-vv-name="jefe/supervisor"></v-text-field>
            </v-flex>

            <v-flex lg2 sm6 xs12 v-if="showField('horario')">
              <v-text-field
                label="Horario"
                v-model="empleoEditor.horario"
                data-vv-name="horario laboral"></v-text-field>
            </v-flex>

            <v-flex
              lg4
              class="hidden-md-and-down"
              v-if="showField('actividad')">
            </v-flex>

            <v-flex lg2 sm6 xs12>
              <ValidationProvider
                name="ingreso neto"
                rules="required|decimal:2|min_value:1000">
                <v-text-field
                  label="Ingreso Mensual Neto"
                  v-model="empleoEditor.ingresoNeto"
                  data-vv-name="ingreso neto"
                  slot-scope="{ errors, valid }"
                  :error-messages="errors"
                  :success="valid"></v-text-field>
              </ValidationProvider>
            </v-flex>

            <v-flex lg2 sm6 xs12>
              <v-autocomplete
                v-model="empleoEditor.diaCobroId"
                :items="listDiasCobro"
                item-text="descripcion"
                item-value="id"
                label="Día de Cobro"
                :disabled="!checkCanAccess('ap-modifica-dia-cobro')"
                :menu-props="{ minWidth: '200' }"></v-autocomplete>
            </v-flex>

            <v-flex lg2 sm6 xs12 v-if="showField('formaCobroId')">
              <v-autocomplete
                v-model="empleoEditor.formaCobroId"
                :items="listFormasCobro"
                item-text="descripcion"
                item-value="id"
                label="Forma Cobro"
                :menu-props="{ minWidth: '200' }"></v-autocomplete>
            </v-flex>

            <v-flex lg4 sm6 xs12 v-if="showField('email')">
              <ValidationProvider name="email" rules="email">
                <v-text-field
                  label="Email"
                  v-model="empleoEditor.email"
                  autocomplete="disabled"
                  data-vv-name="email laboral"
                  slot-scope="{ errors, valid }"
                  :error-messages="errors"
                  :success="valid"></v-text-field>
              </ValidationProvider>
            </v-flex>

            <v-flex lg3 sm6 xs12>
              <ValidationProvider
                name="ingreso liquido"
                rules="required|decimal:2|min_value:0">
                <v-text-field
                  label="Ingreso Liquido"
                  v-model="empleoEditor.ingresoLiquido"
                  data-vv-name="ingreso liquido"
                  slot-scope="{ errors, valid }"
                  :error-messages="errors"
                  :success="valid"></v-text-field>
              </ValidationProvider>
            </v-flex>

            <v-flex xs12>
              <app-manejo-telefonos
                propName="telefonos"
                :value="empleoEditor"
                label="Teléfonos Laborales"></app-manejo-telefonos>
            </v-flex>

            <v-flex v-if="modo != 'comer-web'">
              <v-layout>
                <v-flex>
                  <app-manejo-domicilios
                    propName="domicilios"
                    :value="empleoEditor"
                    :permitirAgregar="modo != 'comer-web'"
                    :permitirEliminar="modo != 'comer-web'"
                    :modoSimple="modo == 'comer-web'"></app-manejo-domicilios>
                </v-flex>
              </v-layout>
            </v-flex>

            <!-- Lista de Empleadores x Nombre -->
            <!-- <app-lista-busqueda label="Búsqueda de Empleadores Por Nombre" :visible.sync="listaEmpleadoresPorNombreVisible" 
                            v-on:update:visivility="listaEmpleadoresPorNombreVisible = $event"
                            :headers="[{text: 'Nombre', value: 'nombre'}, {text: 'CUIT/L', value: 'cui'}]"
                            searchApi="empleadores" :searchFor="'descripcion=' + empleoEditor.empleador"
                            :setSelectedItem="setEmpleadorBusqueda"></app-lista-busqueda> -->

            <!-- Lista de Empleadores x Cui -->
            <app-lista-busqueda
              label="Búsqueda de Empleadores Por CUIL/T"
              :visible.sync="listaEmpleadoresPorCuiVisible"
              v-on:update:visivility="listaEmpleadoresPorCuiVisible = $event"
              :headers="[
                { text: 'Nombre', value: 'nombre' },
                { text: 'CUIT/L', value: 'cui' },
              ]"
              searchApi="empleadores/listarporcui"
              :searchFor="'cui=' + empleoEditor.cui"
              :setSelectedItem="setEmpleadorBusqueda"
              :notFound="setEmpleadorNotFound"></app-lista-busqueda>
          </v-layout>
        </ValidationObserver>
      </v-window-item>

      <!-- Independiente Autónomo -->
      <v-window-item :value="2">
        <ValidationObserver ref="sit2">
          <v-layout wrap>
            <v-flex lg4 sm6 xs12 v-if="showField('actividad')">
              <v-autocomplete
                v-model="empleoEditor.actividadLaboralId"
                :items="listActividadesLaborales"
                item-text="descripcion"
                item-value="id"
                label="Actividad"
                :menu-props="{ minWidth: '200' }"></v-autocomplete>
            </v-flex>

            <v-flex lg2 sm6 xs12>
              <ValidationProvider name="inicio de actividades" rules="required">
                <v-text-field
                  label="Inicio Actividades"
                  v-model="empleoEditor.fechaIngreso"
                  type="date"
                  data-vv-name="fecha de ingreso"
                  slot-scope="{ errors, valid }"
                  :error-messages="errors"
                  :success="valid"></v-text-field>
              </ValidationProvider>
            </v-flex>

            <v-flex
              lg6
              class="hidden-md-and-down"
              v-if="showField('actividad')">
            </v-flex>
            <v-flex lg1 class="hidden-md-and-down" v-else> </v-flex>

            <v-flex lg2 sm6 xs12>
              <ValidationProvider
                name="ingreso neto"
                rules="required|decimal:2|min_value:1000">
                <v-text-field
                  label="Ingreso Mensual Neto"
                  v-model="empleoEditor.ingresoNeto"
                  data-vv-name="ingreso neto"
                  slot-scope="{ errors, valid }"
                  :error-messages="errors"
                  :success="valid"></v-text-field>
              </ValidationProvider>
            </v-flex>

            <v-flex lg2 sm6 xs12>
              <ValidationProvider name="patrimonio neto" rules="decimal:2">
                <v-text-field
                  label="Patrimonio Neto DDJJ"
                  v-model="empleoEditor.patrimonioNetoDdjj"
                  data-vv-name="patrimonio neto"
                  slot-scope="{ errors, valid }"
                  :error-messages="errors"
                  :success="valid"></v-text-field>
              </ValidationProvider>
            </v-flex>

            <v-flex lg4 sm6 xs12>
              <ValidationProvider name="resultado neto" rules="decimal:2">
                <v-text-field
                  label="Resultado Neto DDJJ"
                  v-model="empleoEditor.resultadoNetoDdjj"
                  data-vv-name="resultado neto"
                  slot-scope="{ errors, valid }"
                  :error-messages="errors"
                  :success="valid"></v-text-field>
              </ValidationProvider>
            </v-flex>

            <v-flex
              lg4
              class="hidden-md-and-down"
              v-if="showField('actividad')">
            </v-flex>

            <v-flex lg2 sm6 xs12>
              <v-autocomplete
                v-model="empleoEditor.diaCobroId"
                :items="listDiasCobro"
                item-text="descripcion"
                item-value="id"
                label="Día de Cobro"
                :disabled="!checkCanAccess('ap-modifica-dia-cobro')"
                :menu-props="{ minWidth: '200' }"></v-autocomplete>
            </v-flex>

            <v-flex lg2 sm6 xs12>
              <v-autocomplete
                v-model="empleoEditor.formaCobroId"
                :items="listFormasCobro"
                item-text="descripcion"
                item-value="id"
                label="Forma Cobro"
                :menu-props="{ minWidth: '200' }"></v-autocomplete>
            </v-flex>

            <v-flex lg4 sm6 xs12>
              <ValidationProvider name="email" rules="email">
                <v-text-field
                  label="Email"
                  v-model="empleoEditor.email"
                  autocomplete="disabled"
                  data-vv-name="email laboral"
                  slot-scope="{ errors, valid }"
                  :error-messages="errors"
                  :success="valid"></v-text-field>
              </ValidationProvider>
            </v-flex>

            <v-flex lg3 sm6 xs12>
              <ValidationProvider
                name="ingreso liquido"
                rules="required|decimal:2|min_value:1000">
                <v-text-field
                  label="Ingreso Liquido"
                  v-model="empleoEditor.ingresoLiquido"
                  data-vv-name="ingreso liquido"
                  slot-scope="{ errors, valid }"
                  :error-messages="errors"
                  :success="valid"></v-text-field>
              </ValidationProvider>
            </v-flex>

            <v-flex lg4 class="hidden-md-and-down"> </v-flex>

            <v-flex lg12 sm12 xs12>
              <ValidationProvider
                name="descripcion de la actividad"
                rules="required|max:255">
                <v-text-field
                  label="Breve descripción del trabajo o la actividad"
                  v-model="empleoEditor.descripcion"
                  slot-scope="{ errors, valid }"
                  :error-messages="errors"
                  :success="valid"></v-text-field>
              </ValidationProvider>
            </v-flex>

            <v-flex xs12>
              <app-manejo-telefonos
                propName="telefonos"
                :value="empleoEditor"
                label="Teléfonos Laborales"></app-manejo-telefonos>
            </v-flex>

            <v-flex v-if="modo != 'comer-web'">
              <v-layout>
                <v-flex>
                  <app-manejo-domicilios
                    propName="domicilios"
                    :value="empleoEditor"
                    :permitirAgregar="modo != 'comer-web'"
                    :permitirEliminar="modo != 'comer-web'"
                    :modoSimple="modo == 'comer-web'"></app-manejo-domicilios>
                </v-flex>
              </v-layout>
            </v-flex>
          </v-layout>
        </ValidationObserver>
      </v-window-item>

      <!-- Independiente Monotributista -->
      <v-window-item :value="3">
        <ValidationObserver ref="sit3">
          <v-layout wrap>
            <v-flex lg4 sm6 xs12>
              <v-autocomplete
                v-model="empleoEditor.actividadLaboralId"
                :items="listActividadesLaborales"
                item-text="descripcion"
                item-value="id"
                label="Actividad"
                :menu-props="{ minWidth: '200' }"></v-autocomplete>
            </v-flex>

            <v-flex lg2 sm6 xs12>
              <ValidationProvider name="inicio de actividades" rules="required">
                <v-text-field
                  label="Inicio Actividades"
                  v-model="empleoEditor.fechaIngreso"
                  type="date"
                  data-vv-name="fecha de ingreso"
                  slot-scope="{ errors, valid }"
                  :error-messages="errors"
                  :success="valid"></v-text-field>
              </ValidationProvider>
            </v-flex>

            <v-flex lg2 sm6 xs12>
              <v-text-field
                label="Categoría (A..K)"
                v-model="empleoEditor.categoriaMonotributo"
                data-vv-name="categoria monotributo"></v-text-field>
            </v-flex>

            <v-flex lg2 sm6 xs12>
              <ValidationProvider
                name="ingreso neto"
                rules="required|decimal:2|min_value:1000">
                <v-text-field
                  label="Ingreso Mensual Neto"
                  v-model="empleoEditor.ingresoNeto"
                  data-vv-name="ingreso neto"
                  slot-scope="{ errors, valid }"
                  :error-messages="errors"
                  :success="valid"></v-text-field>
              </ValidationProvider>
            </v-flex>

            <v-flex lg2 class="hidden-md-and-down"> </v-flex>

            <v-flex lg2 sm6 xs12>
              <v-autocomplete
                v-model="empleoEditor.diaCobroId"
                :items="listDiasCobro"
                item-text="descripcion"
                item-value="id"
                label="Día de Cobro"
                :disabled="!checkCanAccess('ap-modifica-dia-cobro')"
                :menu-props="{ minWidth: '200' }"></v-autocomplete>
            </v-flex>

            <v-flex lg2 sm6 xs12>
              <v-autocomplete
                v-model="empleoEditor.formaCobroId"
                :items="listFormasCobro"
                item-text="descripcion"
                item-value="id"
                label="Forma Cobro"
                :menu-props="{ minWidth: '200' }"></v-autocomplete>
            </v-flex>

            <v-flex lg4 sm6 xs12>
              <ValidationProvider name="email" rules="email">
                <v-text-field
                  label="Email"
                  v-model="empleoEditor.email"
                  autocomplete="disabled"
                  data-vv-name="email laboral"
                  slot-scope="{ errors, valid }"
                  :error-messages="errors"
                  :success="valid"></v-text-field>
              </ValidationProvider>
            </v-flex>

            <v-flex lg3 sm6 xs12>
              <ValidationProvider
                name="ingreso liquido"
                rules="required|decimal:2|min_value:1000">
                <v-text-field
                  label="Ingreso Liquido"
                  v-model="empleoEditor.ingresoLiquido"
                  data-vv-name="ingreso liquido"
                  slot-scope="{ errors, valid }"
                  :error-messages="errors"
                  :success="valid"></v-text-field>
              </ValidationProvider>
            </v-flex>

            <v-flex lg4 class="hidden-md-and-down"> </v-flex>

            <v-flex lg12 sm12 xs12>
              <ValidationProvider
                name="descripcion de la actividad"
                rules="required|max:255">
                <v-text-field
                  label="Breve descripción del trabajo o la actividad"
                  v-model="empleoEditor.descripcion"
                  slot-scope="{ errors, valid }"
                  :error-messages="errors"
                  :success="valid"></v-text-field>
              </ValidationProvider>
            </v-flex>

            <v-flex xs12>
              <app-manejo-telefonos
                propName="telefonos"
                :value="empleoEditor"
                label="Teléfonos Laborales"></app-manejo-telefonos>
            </v-flex>

            <v-flex v-if="modo != 'comer-web'">
              <v-layout>
                <v-flex>
                  <app-manejo-domicilios
                    propName="domicilios"
                    :value="empleoEditor"
                    :permitirAgregar="modo != 'comer-web'"
                    :permitirEliminar="modo != 'comer-web'"
                    :modoSimple="modo == 'comer-web'"></app-manejo-domicilios>
                </v-flex>
              </v-layout>
            </v-flex>
          </v-layout>
        </ValidationObserver>
      </v-window-item>

      <!-- Jubilado/Pensionado -->
      <v-window-item :value="4">
        <ValidationObserver ref="sit4">
          <v-layout wrap>
            <v-flex lg2 sm6 xs12>
              <ValidationProvider
                name="ingreso neto"
                rules="required|decimal:2|min_value:1000">
                <v-text-field
                  label="Ingreso Mensual Neto"
                  v-model="empleoEditor.ingresoNeto"
                  data-vv-name="ingreso neto"
                  slot-scope="{ errors, valid }"
                  :error-messages="errors"
                  :success="valid"></v-text-field>
              </ValidationProvider>
            </v-flex>

            <v-flex lg2 sm6 xs12>
              <v-autocomplete
                v-model="empleoEditor.diaCobroId"
                :items="listDiasCobro"
                item-text="descripcion"
                item-value="id"
                label="Día de Cobro"
                :disabled="!checkCanAccess('ap-modifica-dia-cobro')"
                :menu-props="{ minWidth: '200' }"></v-autocomplete>
            </v-flex>

            <v-flex lg2 sm6 xs12>
              <v-autocomplete
                v-model="empleoEditor.formaCobroId"
                :items="listFormasCobro"
                item-text="descripcion"
                item-value="id"
                label="Forma Cobro"
                :menu-props="{ minWidth: '200' }"></v-autocomplete>
            </v-flex>

            <v-flex lg3 sm6 xs12>
              <ValidationProvider
                name="ingreso liquido"
                rules="required|decimal:2|min_value:0">
                <v-text-field
                  label="Ingreso Liquido"
                  v-model="empleoEditor.ingresoLiquido"
                  data-vv-name="ingreso liquido"
                  slot-scope="{ errors, valid }"
                  :error-messages="errors"
                  :success="valid"></v-text-field>
              </ValidationProvider>
            </v-flex>

            <v-flex lg12 sm12 xs12>
              <ValidationProvider
                name="descripcion de la actividad"
                rules="max:255">
                <v-text-field
                  label="Algún comentario extra"
                  v-model="empleoEditor.descripcion"
                  slot-scope="{ errors, valid }"
                  :error-messages="errors"
                  :success="valid"></v-text-field>
              </ValidationProvider>
            </v-flex>
          </v-layout>
        </ValidationObserver>
      </v-window-item>

      <!-- Fuerzas -->
      <v-window-item :value="5">
        <ValidationObserver ref="sit5">
          <v-layout wrap>
            <v-flex lg2 sm6 xs12>
              <v-text-field
                label="Nº Legajo"
                v-model="empleoEditor.legajo"
                data-vv-name="legajo laboral"></v-text-field>
            </v-flex>

            <v-flex lg2 sm6 xs12>
              <ValidationProvider name="inicio de actividades" rules="required">
                <v-text-field
                  label="Inicio Actividades"
                  v-model="empleoEditor.fechaIngreso"
                  type="date"
                  data-vv-name="fecha de ingreso"
                  slot-scope="{ errors, valid }"
                  :error-messages="errors"
                  :success="valid"></v-text-field>
              </ValidationProvider>
            </v-flex>

            <v-flex lg2 sm6 xs12>
              <v-text-field
                label="Superior"
                v-model="empleoEditor.jefe"
                data-vv-name="superior"></v-text-field>
            </v-flex>

            <v-flex lg2 sm6 xs12>
              <ValidationProvider
                name="ingreso neto"
                rules="required|decimal:2|min_value:1000">
                <v-text-field
                  label="Ingreso Mensual Neto"
                  v-model="empleoEditor.ingresoNeto"
                  data-vv-name="ingreso neto"
                  slot-scope="{ errors, valid }"
                  :error-messages="errors"
                  :success="valid"></v-text-field>
              </ValidationProvider>
            </v-flex>

            <v-flex lg4 class="hidden-md-and-down"> </v-flex>

            <v-flex lg2 sm6 xs12>
              <v-autocomplete
                v-model="empleoEditor.diaCobroId"
                :items="listDiasCobro"
                item-text="descripcion"
                item-value="id"
                label="Día de Cobro"
                :disabled="!checkCanAccess('ap-modifica-dia-cobro')"
                :menu-props="{ minWidth: '200' }"></v-autocomplete>
            </v-flex>

            <v-flex lg2 sm6 xs12>
              <v-autocomplete
                v-model="empleoEditor.formaCobroId"
                :items="listFormasCobro"
                item-text="descripcion"
                item-value="id"
                label="Forma Cobro"
                :menu-props="{ minWidth: '200' }"></v-autocomplete>
            </v-flex>

            <v-flex lg4 sm6 xs12>
              <ValidationProvider name="email" rules="email">
                <v-text-field
                  label="Email"
                  v-model="empleoEditor.email"
                  autocomplete="disabled"
                  data-vv-name="email laboral"
                  slot-scope="{ errors, valid }"
                  :error-messages="errors"
                  :success="valid"></v-text-field>
              </ValidationProvider>

              <v-flex lg3 sm6 xs12>
                <ValidationProvider
                  name="ingreso liquido"
                  rules="required|decimal:2|min_value:1000">
                  <v-text-field
                    label="Ingreso Liquido"
                    v-model="empleoEditor.ingresoLiquido"
                    data-vv-name="ingreso liquido"
                    slot-scope="{ errors, valid }"
                    :error-messages="errors"
                    :success="valid"></v-text-field>
                </ValidationProvider>
              </v-flex>
            </v-flex>
          </v-layout>
        </ValidationObserver>
      </v-window-item>

      <!-- Otros -->
      <v-window-item :value="6">
        <ValidationObserver ref="sit6">
          <v-layout wrap>
            <v-flex lg2 sm6 xs12>
              <ValidationProvider
                name="ingreso neto"
                rules="required|decimal:2|min_value:1000">
                <v-text-field
                  label="Ingreso Mensual Neto"
                  v-model="empleoEditor.ingresoNeto"
                  data-vv-name="ingreso neto"
                  slot-scope="{ errors, valid }"
                  :error-messages="errors"
                  :success="valid"></v-text-field>
              </ValidationProvider>
            </v-flex>

            <v-flex lg2 sm6 xs12>
              <v-autocomplete
                v-model="empleoEditor.diaCobroId"
                :items="listDiasCobro"
                item-text="descripcion"
                item-value="id"
                label="Día de Cobro"
                :disabled="!checkCanAccess('ap-modifica-dia-cobro')"
                :menu-props="{ minWidth: '200' }"></v-autocomplete>
            </v-flex>

            <v-flex lg2 sm6 xs12>
              <v-autocomplete
                v-model="empleoEditor.formaCobroId"
                :items="listFormasCobro"
                item-text="descripcion"
                item-value="id"
                label="Forma Cobro"
                :menu-props="{ minWidth: '200' }"></v-autocomplete>
            </v-flex>

            <v-flex lg3 sm6 xs12>
              <ValidationProvider
                name="ingreso liquido"
                rules="required|decimal:2|min_value:1000">
                <v-text-field
                  label="Ingreso Liquido"
                  v-model="empleoEditor.ingresoLiquido"
                  data-vv-name="ingreso liquido"
                  slot-scope="{ errors, valid }"
                  :error-messages="errors"
                  :success="valid"></v-text-field>
              </ValidationProvider>
            </v-flex>

            <v-flex lg4 class="hidden-md-and-down"> </v-flex>

            <v-flex lg12 sm12 xs12>
              <ValidationProvider
                name="descripcion de la actividad"
                rules="required|max:255">
                <v-text-field
                  label="Breve descripción de la fuente de ingresos"
                  v-model="empleoEditor.descripcion"
                  slot-scope="{ errors, valid }"
                  :error-messages="errors"
                  :success="valid"></v-text-field>
              </ValidationProvider>
            </v-flex>
          </v-layout>
        </ValidationObserver>
      </v-window-item>
    </v-window>
  </v-container>
</template>

<script>
import { ValidationObserver, ValidationProvider } from "vee-validate";
import Vue from "vue";
import { http } from "@/axios";
import { mapGetters, mapMutations } from "vuex";

export default {
  components: {
    ValidationObserver,
    ValidationProvider,
  },
  data: () => ({
    loading: false,
    valid: false,
    listaEmpleadoresPorNombreVisible: false,
    listaEmpleadoresPorCuiVisible: false,
    listActividadesLaborales: [],
    listDiasCobro: [],
    listFormasCobro: [],
    listSexos: [],
    listEstadosCiviles: [],
    listSituacionesLaborales: [],
    listSituacionesLaboralesActividadesTodas: [],
    listSituacionesLaboralesActividadesEmpleador: [],
    listSubSituacionesLaborales: [],
    listOrdenEmpleo: [
      { id: 1, descripcion: "Principal" },
      { id: 2, descripcion: "Secundaria" },
      { id: 3, descripcion: "Terciaria" },
    ],
    empleoEditor: {
      orden: null,
      ordenOriginal: null,
      situacionLaboralId: 1,
      subSituacionLaboralId: 0,
      situacionLaboralActividadId: 0,
      descripcion: "",
      fechaIngreso: "1900-01-01",
      ingresoNeto: 0,
      cui: 0,
      empleador: "",
      email: "",
      actividadLaboralId: 0,
      diaCobroId: 0,
      formaCobroId: 0,
      cargo: "",
      seccion: "",
      jefe: "",
      horario: "",
      patrimonioNetoDdjj: 0,
      resultadoNetoDdjj: 0,
      categoriaMonotributo: "",
      domicilios: [],
      telefonos: [],
      ingresoLiquido: 0,
      empleadorId: 0,
    },
    empleadorNotFound: false,
    changing: false,
  }),
  props: {
    empleo: {
      type: Object,
      required: true,
    },
    empleos: {
      type: Array,
      required: false,
    },
    modo: {
      type: String,
      required: false,
      default: "full",
    },
    visible: {
      type: Boolean,
      default: false,
      required: true,
    },
  },
  watch: {
    visible: {
      handler() {
        if (this.visible) {
          this.copiarEmpleo(this.empleo, this.empleoEditor); // hago una copia del empleo para poder modificarlo si afeectar al original
        }
      },
    },
    "empleoEditor.situacionLaboralActividadId"() {
      if (
        this.empleoEditor.situacionLaboralActividadId &&
        this.listSituacionesLaboralesActividadesTodas.length > 0
      ) {
        var actividad = this.listSituacionesLaboralesActividadesTodas.find(
          (act) => act.id === this.empleoEditor.situacionLaboralActividadId,
        );
        this.empleoEditor.situacionLaboralId = actividad.tipoSituacionLaboralId;
      }
    },
    async "empleoEditor.orden"(newValue, oldValue) {
      if (newValue == oldValue || !oldValue) return;

      //alert(oldValue + ' - ' + newValue);
      this.empleoEditor.ordenOriginal = oldValue;
    },
  },
  computed: {
    ...mapGetters(["user", "DebugModeOn", "checkCanAccess"]),
    listSituacionesLaboralesActividadesDisponibles: function () {
      return this.listSituacionesLaboralesActividadesEmpleador.length > 0
        ? this.listSituacionesLaboralesActividadesEmpleador
        : this.listSituacionesLaboralesActividadesTodas;
    },
    uiCarga: function () {
      if (
        !this.empleoEditor.situacionLaboralId ||
        this.listSituacionesLaborales.length === 0
      )
        return 1;

      var ui = this.listSituacionesLaborales.find(
        (s) => s.id == this.empleoEditor.situacionLaboralId,
      ).uiCarga;
      if (ui == 0) ui = 1;

      return ui;
    },
  },
  created() {
    this.loadActividadesLaborales();
    this.loadFormasCobro();
    this.loadDiasCobro();
    this.loadSituacionesLaborales();
    this.loadSituacionesLaboralesActividades();
    this.loadSubSituacionesLaborales();
    this.copiarEmpleo(this.empleo, this.empleoEditor);
  },
  methods: {
    ...mapMutations([
      "alertClear",
      "alertSuccess",
      "alertWarning",
      "alertError",
    ]),
    showField: function (fieldName) {
      if (this.modo == "full") {
        return true;
      }

      if (this.modo == "comer-web" && fieldName == "legajo") return false;
      if (this.modo == "comer-web" && fieldName == "jefe") return false;
      if (this.modo == "comer-web" && fieldName == "horario") return false;
      if (this.modo == "comer-web" && fieldName == "formaCobroId") return false;
      if (this.modo == "comer-web" && fieldName == "cargo") return false;
      if (this.modo == "comer-web" && fieldName == "seccion") return false;
      if (this.modo == "comer-web" && fieldName == "fechaIngreso") return false;
      if (this.modo == "comer-web" && fieldName == "email") return false;
      if (this.modo == "comer-web" && fieldName == "actividad") return false;

      return true;
    },
    copiarEmpleo(source, destination) {
      Vue.set(destination, "orden", source.orden);
      Vue.set(destination, "id", source.id);
      Vue.set(destination, "cui", source.cui);
      Vue.set(destination, "empleador", source.empleador);
      Vue.set(destination, "email", source.email);
      Vue.set(
        destination,
        "fechaIngreso",
        this.$moment(source.fechaIngreso).format("YYYY-MM-DD"),
      );
      Vue.set(destination, "actividadLaboralId", source.actividadLaboralId);
      Vue.set(destination, "diaCobroId", source.diaCobroId);
      Vue.set(destination, "formaCobroId", source.formaCobroId);
      Vue.set(destination, "cargo", source.cargo);
      Vue.set(destination, "seccion", source.seccion);
      Vue.set(destination, "jefe", source.jefe);
      Vue.set(destination, "legajo", source.legajo);
      Vue.set(destination, "horario", source.horario);
      Vue.set(destination, "ingresoNeto", source.ingresoNeto);
      Vue.set(destination, "ingresoLiquido", source.ingresoLiquido);
      Vue.set(destination, "patrimonioNetoDdjj", source.patrimonioNetoDdjj);
      Vue.set(destination, "resultadoNetoDdjj", source.resultadoNetoDdjj);
      Vue.set(destination, "situacionLaboralId", source.situacionLaboralId);
      Vue.set(
        destination,
        "subSituacionLaboralId",
        source.subSituacionLaboralId,
      );
      Vue.set(destination, "empleadorId", source.empleadorId);

      Vue.set(
        destination,
        "situacionLaboralActividadId",
        source.situacionLaboralActividadId,
      );
      Vue.set(destination, "categoriaMonotributo", source.categoriaMonotributo);
      Vue.set(destination, "descripcion", source.descripcion);
      Vue.set(destination, "domicilios", source.domicilios);
      Vue.set(destination, "telefonos", source.telefonos);
      Vue.set(
        destination,
        "situacionLaboralDescripcion",
        source.situacionLaboralDescripcion,
      );
      Vue.set(
        destination,
        "situacionLaboralActividadDescripcion",
        source.situacionLaboralActividadDescripcion,
      );
      // alert("source: " + source.empleadorId);
      // alert("destination: " + destination.empleadorId);
      if (destination.domicilios.length == 0) {
        destination.domicilios.push({
          calle: "",
          numero: "",
          piso: "",
          departamento: "",
          entreCalle1: "",
          entreCalle2: "",
          barrio: "",
          localidad: "",
          codigoPostal: "",
          partido: "",
          provincia: "",
          orden: 1,
        });
      }
    },
    async validar() {
      if (this.empleadorNotFound) {
        this.alertWarning(
          "No se encontró el empleador ingresado. Imposible continuar.",
        );
        return false;
      }

      var result = await this.$refs.general.validate();
      if (!result) {
        console.log("Hay Errores Generales");
      }

      if (
        this.empleoEditor.ordenOriginal &&
        this.empleoEditor.ordenOriginal != this.empleoEditor.orden
      ) {
        const res = await this.$dialog.confirm({
          text: "¿Confirma la modificación de la prioridad?",
          title: "Modificación de Prioriadd de Empleo",
          persistent: true, // Parece que no funciona...
        });

        if (!res) {
          this.empleoEditor.orden = this.empleoEditor.ordenOriginal;
          return;
        } else {
          // si hubo un cambio de orden en los empleos, modifico la lista

          if (this.empleos && this.empleoEditor.ordenOriginal) {
            //console.log('orden original: ' + this.empleoEditor.ordenOriginal);

            if (this.empleo.ordenOriginal != this.empleoEditor.orden) {
              var empleoOriginal = this.empleos.find(
                (item) => item.orden == this.empleoEditor.orden,
              );

              //console.log('empleo original: ' + empleoOriginal);
              if (empleoOriginal) {
                empleoOriginal.orden = this.empleoEditor.ordenOriginal;
              }
            }
          }
        }
      }

      switch (this.empleoEditor.situacionLaboralId) {
        case 1:
          console.log("Validando Situación 1");
          result = await this.$refs.sit1.validate();
          if (!result) {
            console.log("Hay Errores");
          }
          break;
        case 2:
          console.log("Validando Situación 2");
          result = await this.$refs.sit2.validate();
          if (!result) {
            console.log("Hay Errores");
          }
          break;
        case 3:
          console.log("Validando Situación 3");
          result = await this.$refs.sit3.validate();
          if (!result) {
            console.log("Hay Errores");
          }
          break;
        case 4:
          console.log("Validando Situación 4");
          result = await this.$refs.sit4.validate();
          if (!result) {
            console.log("Hay Errores");
          }
          break;
        case 5:
          console.log("Validando Situación 5");
          result = await this.$refs.sit5.validate();
          if (!result) {
            console.log("Hay Errores");
          }
          break;
        case 6:
          console.log("Validando Situación 6");
          result = await this.$refs.sit6.validate();
          if (!result) {
            console.log("Hay Errores");
          }
          break;

        default:
          break;
      }

      if (!result) {
        this.alertWarning(
          "Por favor, verifique/complete los datos e intente nuevamnte.",
        );
        return false;
      }

      this.copiarEmpleo(this.empleoEditor, this.empleo);
      return true;
    },
    async loadActividadesLaborales() {
      this.loading = true;
      try {
        var result = await http.get("tiposactividadlaboral"); // traigo todas
        this.listActividadesLaborales = result.list;
      } catch (error) {
        // Error
        this.alertError(error);
      }
      this.loading = false;
    },
    async loadDiasCobro() {
      this.loading = true;
      try {
        var result = await http.get("tiposdiacobro"); // traigo todas
        this.listDiasCobro = result.list;
      } catch (error) {
        // Error
        this.alertError(error);
      }
      this.loading = false;
    },
    async loadFormasCobro() {
      this.loading = true;
      try {
        var result = await http.get("tiposformacobro"); // traigo todas
        this.listFormasCobro = result.list;
      } catch (error) {
        // Error
        this.alertError(error);
      }
      this.loading = false;
    },
    async loadSituacionesLaborales() {
      this.loading = true;
      try {
        var result = await http.get("situacioneslaborales/listarparaingreso"); // traigo todas
        this.listSituacionesLaborales = result.list;
      } catch (error) {
        // Error
        this.alertError(error);
      }
      this.loading = false;
    },
    async loadSituacionesLaboralesActividades() {
      this.loading = true;
      try {
        var result = await http.get("situacioneslaborales/actividades");
        this.listSituacionesLaboralesActividadesTodas = result.list;
      } catch (error) {
        this.alertError(error);
      }
      this.loading = false;
    },
    async loadSubSituacionesLaborales() {
      this.loading = true;
      try {
        var result = await http.get("tiposSubSituacionLaboral"); // traigo todas
        this.listSubSituacionesLaborales = result.list;

        //this.setHintSituacionLaboral();
      } catch (error) {
        // Error
        this.alertError(error);
      }
      this.loading = false;
    },
    async buscarEmpleadorPorNombre() {
      this.listaEmpleadoresPorNombreVisible = true;
    },
    async buscarEmpleadorPorCui() {
      this.listaEmpleadoresPorCuiVisible = true;
    },
    setEmpleadorBusqueda(empleador) {
      this.empleoEditor.empleador = empleador.nombre;
      this.empleoEditor.cui = empleador.cui;
      this.empleoEditor.diaCobroId = empleador.diaCobroId;
      this.empleoEditor.actividadLaboralId = empleador.tipoActividadLaboralId;
      this.empleoEditor.empleadorId = empleador.id;
      this.listSituacionesLaboralesActividadesEmpleador =
        empleador.tiposSituacionLaboralActividad;
      this.empleoEditor.situacionLaboralActividadId =
        this.listSituacionesLaboralesActividadesEmpleador.length > 0
          ? Math.min.apply(
              Math,
              this.listSituacionesLaboralesActividadesEmpleador.map(
                (sit) => sit.id,
              ),
            )
          : 0;

      this.empleadorNotFound = false;
    },
    setEmpleadorNotFound() {
      this.empleadorNotFound = true;
    },
  },
};
</script>
